import { z } from "zod";
export const legalDocumentKeySchema = z.enum(["offer", "privacy", "pdConsent"]);
export const legalDocumentVersionsSchema = z.object({
    offer: z.string().uuid(), privacy: z.string().uuid(), pdConsent: z.string().uuid(),
}).strict();
export const legalDocumentEditionDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((value) => {
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}, "Дата должна существовать в календаре");
const versionFields = {
    id: z.string().uuid(), key: legalDocumentKeySchema, title: z.string(),
    editionDate: legalDocumentEditionDateSchema, sha256: z.string().regex(/^[a-f0-9]{64}$/),
    size: z.number().int().positive().max(10 * 1024 * 1024),
};
export const legalDocumentVersionSchema = z.object({
    ...versionFields, publishedAt: z.string().datetime(), url: z.string().url(),
}).strict();
export const adminLegalDocumentVersionSchema = z.object({
    ...versionFields, publishedAt: z.string().datetime().nullable(), url: z.string().url().nullable(),
    uploadedAt: z.string().datetime().nullable(), uploadedBy: z.string().uuid().nullable(),
    publishedBy: z.string().uuid().nullable(), isCurrent: z.boolean(), previewUrl: z.string().url(),
}).strict();
export const legalDocumentCatalogItemSchema = z.object({
    key: legalDocumentKeySchema, revision: z.number().int().nonnegative(),
    activeVersion: legalDocumentVersionSchema.nullable(),
}).strict();
export const legalDocumentCatalogSchema = z.object({ items: z.array(legalDocumentCatalogItemSchema) }).strict();
export const adminLegalDocumentCatalogItemSchema = z.object({
    key: legalDocumentKeySchema, revision: z.number().int().nonnegative(),
    activeVersion: adminLegalDocumentVersionSchema.nullable(),
}).strict();
export const adminLegalDocumentCatalogSchema = z.object({ items: z.array(adminLegalDocumentCatalogItemSchema) }).strict();
export const legalDocumentUploadMetadataSchema = z.object({
    requestId: z.string().uuid(), editionDate: legalDocumentEditionDateSchema,
}).strict();
export const legalDocumentPublishInputSchema = z.object({
    requestId: z.string().uuid(), versionId: z.string().uuid(), expectedRevision: z.number().int().nonnegative(),
}).strict();
export const legalDocumentHistoryQuerySchema = z.object({
    cursor: z.string().min(1).max(4096).optional(), limit: z.coerce.number().int().min(1).max(100).default(20),
}).strict();
export const legalDocumentHistoryPageSchema = z.object({
    items: z.array(adminLegalDocumentVersionSchema), nextCursor: z.string().nullable(),
}).strict();
//# sourceMappingURL=legal-documents.js.map